// What the asset panel shows of the loaded page: its size, and the scope, type and sort on top of it.
import { isArchived, assetKind, statusRank } from "./assetStatus.js";
import { assetTitle } from "./assetLabels.js";

/** One request loads at most this many assets; the header marks a full page with "+". */
export const PAGE_LIMIT = 300;

export const KINDS = [
  { value: "all", label: "All" },
  { value: "video", label: "Video" },
  { value: "audio", label: "Audio" },
];

export const SCOPES = [
  { value: "global", label: "Global" },
  { value: "local", label: "Local" },
  { value: "archive", label: "Archive" },
];

// ponytail: filters only the loaded page (at most PAGE_LIMIT hits); move them into the search request if that bites.
// ponytail: the kind is guessed from the codec (assetKind), so an empty codec counts as video.
export function filterAssets(assets, { scope, folderId, searching, kind = "all" }) {
  return assets.filter((asset) => {
    if (scope === "local" && searching && (asset.parentID || null) !== (folderId || null)) return false;
    if (scope === "archive" && !isArchived(asset)) return false;
    if (kind !== "all" && assetKind(asset) !== kind.toUpperCase()) return false;
    return true;
  });
}

// Each sort asks the server for a fixed field and order; some re-order the loaded page on top.
// ponytail: those client sorts only order the loaded page, not everything the search matches.
export const SORTS = {
  newest: { label: "Newest", field: "created", order: "desc" },
  title: { label: "Title A–Z", field: "title", order: "asc", compare: (a, b) => assetTitle(a).localeCompare(assetTitle(b)) },
  tapeID: { label: "Tape ID", field: "tapeID", order: "asc" },
  longest: { label: "Longest", field: "created", order: "desc", compare: byLength },
  status: { label: "Status", field: "created", order: "desc", compare: (a, b) => statusRank(a) - statusRank(b) },
};

/** Known lengths, longest first; unknown ones last. */
function byLength(a, b, durationOf) {
  const lengthA = durationOf(a.id) || 0;
  const lengthB = durationOf(b.id) || 0;
  return lengthB - lengthA;
}

/** A stable sort, so ties keep the server's newest-first order. */
export function sortAssets(assets, key, { durationOf = () => undefined } = {}) {
  const compare = SORTS[key] && SORTS[key].compare;
  if (!compare) return assets;
  return [...assets].sort((a, b) => compare(a, b, durationOf));
}
